module.exports = __webpack_public_path__ + "static/art-2-43c6b2089c019670b89c1815509810a3.jpg";